import Glide from "@glidejs/glide";
import "@glidejs/glide/dist/css/glide.core.min.css";

export default (ref, itemsPerPage, gap, focusAt, marginLeft, marginRight) => ({
  ref: ref,
  itemsPerPage: itemsPerPage,
  gap: gap,
  focusAt: focusAt,
  marginLeft: marginLeft,
  marginRight: marginRight,
  carousel: undefined,

  init() {
    this.$nextTick(() => {
      this.carousel = new Glide(this.$refs[this.ref], {
        autoplay: 4000,
        type: "carousel",
        perView: this.itemsPerPage,
        gap: this.gap,
        focusAt: this.focusAt,
        peek: {
          before: this.marginLeft,
          after: this.marginRight,
        },
        breakpoints: {
          768: {
            perView: 2,
            peek: {
              before: 0,
              after: 100,
            },
          },
          600: {
            perView: 1,
            peek: {
              before: 0,
              after: 100,
            },
          }
        },
      }).mount();
    });
  },
});
